import axios from 'axios';
import qs from 'qs';
import client from './client';

//회사정보 가져오기
export const getCompanies = () => axios.get('/api/v1/user/company');

// //로그인
// export const login = (dataToSubmit) =>
//   axios.post('/api/v1/user/login', dataToSubmit);
export const login = (dataToSubmit) =>
  axios.post('/api/v1/user/login', dataToSubmit, {
    headers: { companyCd: dataToSubmit?.company },
    // 2026-10-16: 로그인 응답이 HttpOnly 리프레시 쿠키(refresh_token)를 Set-Cookie로 내려준다 —
    // 브라우저가 그걸 저장/전송하게 하려면 true여야 한다.
    withCredentials: true,
  });

// 2026-10-16: 현재 기기 로그아웃 — 서버의 리프레시 세션을 폐기하고 쿠키도 지운다.
export const logout = () => client.post('/api/v1/user/logout');

// 로그인된 기기 목록 ("로그인된 기기" 프로필 화면)
export const getSessions = () => client.get('/api/v1/user/sessions');

// 특정 기기 로그아웃
export const revokeSession = (sessionId) =>
  client.delete(`/api/v1/user/sessions/${sessionId}`);

// 이 기기를 제외한 나머지 전체 로그아웃
export const revokeOtherSessions = () => client.delete('/api/v1/user/sessions');

//유저정보
export const getUser = (data) =>
  axios.get('/api/v1/user/info', {
    headers: {
      Authorization: `Bearer ${data.token}`,
      companyCd: `${data?.companyCd}`,
    },
  });

export const getTodayBootstrap = () => client.post('/api/v1/user/today/bootstrap');

//공통코드 가져오기
export const getBaseCode = (filterObject) => {
  const queryString = qs.stringify(filterObject);
  return client.get(`/api/v1/common/list?${queryString}`);
};

export const check = () =>
  axios.get('/api/v1/user/info', {
    headers: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem('access_token'),
      )}`,
    },
  });

//유저 정보 수정
export const editUserInfo = (dataToSubmit) => {
  return client.put(`/api/v1/user/info`, dataToSubmit);
};

//비밀번호 수정
export const changePwd = (dataToSubmit) => {
  return client.put(`/api/v1/user/changePwd`, dataToSubmit);
};

//결재 리스트 가져오기
export const getApprovals = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`/api/v1/common/approval/now?${queryString}`);
};

//내 캘린더 내역
export const getSchedules = (searchData) => {
  return client.get(`/api/v1/schedule/list`);
};

//노티 정보 가져오기
export const getNoties = () => {
  return client.get(`/api/v1/noti/list`);
};

//노티 정보 전체 확인 
export const confirmNotiAll = () => {
  return client.put(`/api/v1/noti/lists`);
};

//노티 확인
export const confirmNoties = (checkedNoties) => {
  // const queryString = qs.stringify(checkedNoties);
  //return client.put(`/api/v1/noti/info?${queryString}`);
  return client.put(`/api/v1/noti/info?arr=${checkedNoties}`);
};

//프로젝트 카운트 정보 가져오기(top menu)
export const getProjectCounts = () => {
  return client.get(`/api/v1/project/campaign/status/cnt`);
};
